export function calculateWeightedValue(value, probability) {
  const safeValue = Math.max(0, Number(value) || 0)
  const safeProbability = Math.min(100, Math.max(0, Number(probability) || 0))
  return safeValue * safeProbability / 100
}
